module.exports = __webpack_public_path__ + "static/media/saurabh.7db0e497.jpg";